import { createButton, createElement } from "./dom";

export class LoadingScreen {
  public readonly element = createElement("section", "screen loading-screen hidden");
  private readonly label = createElement("span", "loading-stage");
  private readonly progress = createElement("progress");
  private readonly back = createButton("ОТМЕНИТЬ", () => this.onCancel());
  public onCancel: () => void = () => undefined;

  public constructor() {
    const indicator = createElement("div", "loading-indicator");
    indicator.setAttribute("aria-hidden", "true");
    this.element.setAttribute("role", "status");
    this.element.setAttribute("aria-live", "polite");
    this.element.append(
      indicator,
      createElement("strong", undefined, "ПОДГОТОВКА СПУСКА"),
      this.label,
      this.progress,
      this.back,
    );
    this.progress.max = 100;
    this.progress.setAttribute("aria-label", "Готовность спуска");
  }

  public show(): void {
    this.back.textContent = "ОТМЕНИТЬ";
    this.element.classList.remove("load-error");
    this.setProgress("ПОДКЛЮЧЕНИЕ ТЕРМИНАЛА", 0);
    this.element.classList.remove("hidden");
  }

  public setProgress(label: string, percent: number): void {
    this.label.textContent = label;
    this.progress.value = percent;
  }

  public showError(): void {
    this.element.classList.add("load-error");
    this.label.textContent =
      "Не удалось запустить спуск. Вернитесь в меню и попробуйте низкое качество графики.";
    this.back.textContent = "В МЕНЮ";
  }

  public hide(): void {
    this.element.classList.add("hidden");
  }
}
